import React from "react"
import { Outlet, useParams, useLocation } from "react-router-dom"
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
} from "@chakra-ui/react"
import { ChevronRightIcon } from "@chakra-ui/icons"
import Sidebar from "./Sidebar"
import Link from "./Link"
import { Datasets, Schemas } from "../lib/store"
import Pixel from "./Pixel"
import SidebarFooter from "./SidebarFooter"
import breadcrumbs from "../lib/breadcrumbs"
import { generateBreadcrumbs } from "../lib/util"

function useBreadcrumbs() {
  const location = useLocation()
  const params = useParams()
  const [datasets] = Datasets.useState()
  const [schemas] = Schemas.useState()

  return generateBreadcrumbs(location.pathname, breadcrumbs, [], params, {
    datasets,
    schemas,
  })
}

export default function SidebarLayout() {
  const breadcrumbs = useBreadcrumbs()

  return (
    <Box
      display="flex"
      flexDirection={{ base: "column", md: "row" }}
      height="100vh"
      maxW="100vw"
      overflow="hidden"
    >
      <Sidebar />
      <Box
        maxWidth={{ base: "100vw", md: "calc(100vw - 14em)" }}
        minWidth={{ base: "100vw", md: "calc(100vw - 14em)" }}
        height={{ base: "calc(100vh - 4em)", md: "100vh" }}
        bg="Gray.100"
      >
        <Flex
          flexDirection="column"
          minWidth="100%"
          height="100%"
          alignItems="flex-start"
        >
          <Breadcrumb
            spacing="8px"
            ml={["1em", "1em", "2em"]}
            separator={<ChevronRightIcon color="gray.500" />}
          >
            {breadcrumbs
              .filter((crumb) => crumb.label)
              .map((crumb) => (
                <BreadcrumbItem
                  key={crumb.path}
                  isCurrentPage={crumb.current}
                  height="2.5em"
                >
                  <BreadcrumbLink as={Link} to={crumb.path}>
                    {crumb.label}
                  </BreadcrumbLink>
                </BreadcrumbItem>
              ))}
          </Breadcrumb>
          <Flex direction="column" flexGrow={1} minHeight={0} width="100%">
            <Outlet />
          </Flex>
          <SidebarFooter />
        </Flex>
      </Box>
      <Pixel />
    </Box>
  )
}
